import { render, staticRenderFns } from "./studentClassRecord.vue?vue&type=template&id=2bde42f2&"
import script from "./studentClassRecord.vue?vue&type=script&lang=js&"
export * from "./studentClassRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports